/* istanbul ignore file */
import { boolean as codecBoolean } from 'purify-ts/Codec';
import { utils as coreUtils } from '@codegrade/api-core';
import { parsers } from '@codegrade/utils';
const Lti1p3ParseMostPrivilegedRoleSettingParser = 
/* #__PURE__ */ parsers.object([
    ['name', /* #__PURE__ */ parsers.exactly('LTI_1P3_PARSE_MOST_PRIVILEGED_ROLE')],
    ['value', /* #__PURE__ */ parsers.maybeNull(codecBoolean)],
]);
export class Lti1p3ParseMostPrivilegedRoleSetting extends /* #__PURE__ */ coreUtils.AssigningBase {
    static decode(input) {
        return Lti1p3ParseMostPrivilegedRoleSettingParser.decode(input).map(res => new Lti1p3ParseMostPrivilegedRoleSetting(res));
    }
    static unsafeDecode(input) {
        return Lti1p3ParseMostPrivilegedRoleSetting.decode(input).unsafeCoerce();
    }
    static encode(data) {
        return Lti1p3ParseMostPrivilegedRoleSettingParser.encode(data);
    }
    static schema() {
        return Lti1p3ParseMostPrivilegedRoleSettingParser.schema();
    }
}
